import { CustomButton } from "@/components/ui/Buttons";
import Modal from "@/components/ui/Modal";
import { Turtle } from "lucide-react";
import React from "react";

type ConfirmationModalProps = {
  title: string;
  isOpen: boolean;
  onConfirm: (value: boolean) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ConfirmationModal = ({
  title,
  isOpen,
  onConfirm,
  setOpen,
}: ConfirmationModalProps) => {
  if (!isOpen) return null;

  return (
    <Modal width="360px" isOpen={isOpen} setOpen={setOpen}>
      <div className="w-full">
        <p className="text-[16px] text-center font-medium text-[#475467]">
          {" "}
          {title}
        </p>

        <div className="mt-6 flex w-full gap-3">
          <CustomButton
            color="#344054"
            onClick={() => setOpen(false)}
            fontSize="16px"
            fontWeight="600"
            backgroundColor="#D0D5DD"
            variant="outline"
            className="w-full"
          >
            No
          </CustomButton>

          <CustomButton
            onClick={() => onConfirm(true)}
            fontSize="16px"
            fontWeight="600"
            backgroundColor="#17457D"
            className="w-full"
          >
            Yes
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
